import { Directive, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormArray } from '@angular/forms';
import { shareOneReplay } from '@examdojo/core/rxjs';
import { getOrderedItemTagValue, QuestionItemTypeEnum } from '@examdojo/models/question';
import { combineLatest, map, Observable, startWith, switchMap } from 'rxjs';
import { TopLevelFormGroup } from '../question-item-editor.model';

@Directive({
  selector: '[dojoStemLabel]',
  standalone: true,
})
export class StemLabelStateManagerDirective {
  readonly formArray = input.required<FormArray<TopLevelFormGroup>>({ alias: 'dojoStemLabel' });
  readonly labelsArray = input<string[]>();

  readonly formValue$ = toObservable(this.formArray).pipe(
    switchMap((form) => form.valueChanges.pipe(startWith(form.value))),
  );

  readonly labelMap$: Observable<Map<number, string | undefined>> = combineLatest([
    this.formValue$,
    toObservable(this.labelsArray),
  ]).pipe(
    map(([formValue, labelsArray]) => {
      const labelMap = new Map<number, string>();
      let labelIndex = 0;

      formValue.forEach((item, index: number) => {
        if (item.type === QuestionItemTypeEnum.Stem || item.type === QuestionItemTypeEnum.StemGroup) {
          labelMap.set(index, labelsArray?.[labelIndex] ?? getOrderedItemTagValue(labelIndex));
          labelIndex++;
        }
      });

      return labelMap;
    }),
    shareOneReplay(),
  );
}
